import axios from "axios";
import Layout from "@/components/Layout/Layout";

// Pages
import Dashboard from "@/pages/Dashboard/Dashboard";
import Projetos from "@/pages/Projetos/Projetos";
import Pessoas from "@/pages/Pessoas/Pessoas";
import Organizacoes from "@/pages/Organizacoes/Organizacoes";

import Login from "@/pages/Login/Login";
import RecuperaSenha from "@/pages/RecuperaSenha/RecuperarSenha";
import MensagemRecuperaSenha from "@/pages/MensagemSenha/MensagemSenha";
import NovaSenha from "@/pages/NovaSenha/NovaSenha";

// Projeto
import ProjetoLayout from "@/pages/Projeto/components/Layout/ProjetoLayout";
import Matriz from "@/pages/Projeto/pages/Matriz/Matriz";
import Projeto from "@/pages/Projeto/pages/Projeto/Projeto";
import Impacto from "@/pages/Projeto/pages/Impacto/Impacto";
import Realizacao from "@/pages/Projeto/pages/Realizacao/Realizacao";
import Produto from "@/pages/Projeto/pages/Produto/Produto";
import Atividade from "@/pages/Projeto/pages/Atividade/Atividade";

//Prestação de Contas
import Contas from "@/pages/Projeto/pages/Contas/Contas";
import PrestacaoContaDetalhes from "@/pages/Projeto/pages/Contas/Detalhes/PrestacaoContaDetalhes";

//Pessoas Alcaçadas pelo Projeto
import PessoasAlcancadas from "@/pages/Projeto/pages/PessoasAlcancadas/PessoasAlcancadas";
import RelatorioPessoas from "@/pages/Projeto/pages/PessoasAlcancadas/Relatorio/RelatorioPessoas";

import IndicadorDetalhes from "@/pages/Projeto/pages/Impacto/IndicadorDetalhes";

export default [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/solicitar-nova-senha",
    name: "RecuperaSenha",
    component: RecuperaSenha,
  },
  {
    path: "/mensagem-recuperar-senha",
    name: "MensagemRecuperaSenha",
    component: MensagemRecuperaSenha,
    props: true,
  },
  {
    path: "/novaSenha",
    meta: {
      public: true,
    },
    name: "NovaSenha",
    component: NovaSenha,
    beforeEnter: (to, from, next) => {
      axios
        .get(`public/usuario/validar-token?token=${to.query.hash}`)
        .then(function(data) {
          if (data && data.status === 200) {
            return next();
          } else {
            return next("/tokenInvalido");
          }
        });
    },
  },
  {
    path: "/",
    redirect: "login",
    name: "Layout",
    component: Layout,
    meta: {
      requiresAuth: true,
      breadCrumbName: "Projetos",
      permissions: [
        { role: "ADMINISTRADOR", access: true },
        { role: "USUARIO", access: true },
      ],
    },
    children: [
      {
        path: "/inicio",
        name: "Projetos",
        component: Projetos,
      },
      {
        path: "/pessoas",
        name: "Pessoas",
        component: Pessoas,
      },
      {
        path: "/organizacoes",
        name: "Organizacoes",
        component: Organizacoes,
      },
    ],
  },

  {
    path: "/projetos/:projetoId",
    redirect: (to) => {
      let redirectPath = "/projetos/{projetoId}/detalhes".replace(
        new RegExp("{projetoId}", "g"),
        to.params.projetoId
      );
      return { path: redirectPath };
    },
    name: "ProjetoLayout",
    component: ProjetoLayout,
    meta: {
      requiresAuth: true,
      breadCrumbName: "Projeto",
      permissions: [
        { role: "ADMINISTRADOR", access: true },
        { role: "USUARIO", access: true },
      ],
    },
    children: [
      {
        path: "/projetos/:projetoId/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { breadCrumbName: "Dashboard" },
      },
      {
        path: "/projetos/:projetoId/detalhes",
        name: "Projeto",
        component: Projeto,
        meta: {
          breadCrumbName: "Detalhes do Projeto",
        },
      },
      {
        path: "/projetos/:projetoId/contas",
        meta: { breadCrumbName: "Prestação de Contas" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Contas",
            component: Contas,
          },
          {
            path: "/projetos/:projetoId/contas/:prestacaoContaId",
            name: "PrestacaoContaDetalhes",
            component: PrestacaoContaDetalhes,
          },
        ],
      },
      {
        path: "/projetos/:projetoId/matriz",
        meta: { breadCrumbName: "Matriz" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "Matriz",
            component: Matriz,
          },
          {
            path: "/projetos/:projetoId/matriz/impacto/:logicaIntervencaoId",
            meta: {
              breadCrumbName: "Impacto",
            },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "",
                name: "Impacto",
                component: Impacto,
              },
              {
                path:
                  "/projetos/:projetoId/matriz/impacto/:logicaIntervencaoId/indicador/:indicadorId",
                name: "IndicadorImpacto",
                component: IndicadorDetalhes,
                meta: {
                  breadCrumbName: "Indicador",
                },
              },
            ],
          },
          {
            path: "/projetos/:projetoId/matriz/realizacao/:logicaIntervencaoId",
            meta: {
              breadCrumbName: "Realização",
            },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "",
                name: "Realizacao",
                component: Realizacao,
              },
              {
                path:
                  "/projetos/:projetoId/matriz/realizacao/:logicaIntervencaoId/indicador/:indicadorId",
                name: "IndicadorRealizacao",
                component: IndicadorDetalhes,
                meta: {
                  breadCrumbName: "Indicador",
                },
              },
            ],
          },
          {
            path: "/projetos/:projetoId/matriz/produto/:logicaIntervencaoId",
            meta: {
              breadCrumbName: "Produto",
            },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "",
                name: "Produto",
                component: Produto,
              },
              {
                path:
                  "/projetos/:projetoId/matriz/produto/:logicaIntervencaoId/indicador/:indicadorId",
                name: "IndicadorProduto",
                component: IndicadorDetalhes,
                meta: {
                  breadCrumbName: "Indicador",
                },
              },
            ],
          },
          {
            path: "/projetos/:projetoId/matriz/atividade/:logicaIntervencaoId",
            meta: {
              breadCrumbName: "Atividade",
            },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            children: [
              {
                path: "",
                name: "Atividade",
                component: Atividade,
              },
              {
                path:
                  "/projetos/:projetoId/matriz/atividade/:logicaIntervencaoId/indicador/:indicadorId",
                name: "IndicadorAtividade",
                component: IndicadorDetalhes,
                meta: {
                  breadCrumbName: "Indicador",
                },
              },
            ],
          },
        ],
      },
      {
        path: "/projetos/:projetoId/pessoas-alcancadas",
        meta: { breadCrumbName: "Pessoas Alcançadas" },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "PessoasAlcancadas",
            component: PessoasAlcancadas,
          },
          {
            path: "relatorios",
            name: "RelatorioPessoas",
            component: RelatorioPessoas,
            meta: { breadCrumbName: "Relatórios" },
          },
        ],
      },
    ],
  },
];
